// extracted by mini-css-extract-plugin
export default {"container":"zoomableImage_container__D5GTY","transform":"zoomableImage_transform__2RzzP","image":"zoomableImage_image__XJcMt","pannable":"zoomableImage_pannable__zVafT"};